import axios from 'axios'

export interface ThreadSummary {
  id: string
  subject?: string
  participant_ids: string[]
  created_at: string
}

export interface MessageOut {
  id: string
  thread_id: string
  sender_id: string
  body: string
  created_at: string
}

const API_BASE = `${import.meta.env.VITE_API_BASE_URL ?? ''}/communications`

const buildHeaders = (tenantId: string) => {
  const headers: Record<string, string> = {}
  const token = localStorage.getItem('token')
  if (tenantId) headers['X-Tenant-ID'] = tenantId
  if (token) headers['Authorization'] = `Bearer ${token}`
  return headers
}

export const listThreads = async (tenantId: string): Promise<ThreadSummary[]> => {
  const response = await axios.get(`${API_BASE}/threads`, { headers: buildHeaders(tenantId) })
  return response.data
}

export const createThread = async (
  tenantId: string,
  subject: string | undefined,
  participantIds: string[]
): Promise<ThreadSummary> => {
  const response = await axios.post(
    `${API_BASE}/threads`,
    { subject, participant_ids: participantIds },
    { headers: buildHeaders(tenantId) }
  )
  return response.data
}

export const listMessages = async (tenantId: string, threadId: string): Promise<MessageOut[]> => {
  const response = await axios.get(`${API_BASE}/threads/${threadId}/messages`, {
    headers: buildHeaders(tenantId),
  })
  return response.data
}

export const sendMessage = async (
  tenantId: string,
  threadId: string,
  body: string
): Promise<MessageOut> => {
  const response = await axios.post(
    `${API_BASE}/threads/${threadId}/messages`,
    { body },
    { headers: buildHeaders(tenantId) }
  )
  return response.data
}

export const markThreadRead = async (tenantId: string, threadId: string): Promise<void> => {
  await axios.post(`${API_BASE}/threads/${threadId}/read`, null, {
    headers: buildHeaders(tenantId),
  })
}
